import { ContentService } from "@DavisDigital/davisdigitalfrontend.module";
import { FolderTypes } from "@DavisDigital/interfaces";


class AddEditFolderModalController {
    
    private close:Function; //injected from modal-service
    
    public folderId:    string;
    public folderName:  string;
    public folderType:  FolderTypes;
    public sourcePage: string = "";
    
    public modalTitle:  "Create Folder" | "Edit Folder" = "Create Folder";
    public modalInputLabel: string;
    public successMessage: string;
    public isLoading = false;
    public isSaveSuccess = false;
    public isOpen = false;
	
	private previouslyFocusedElement: HTMLElement | null = null;
	private focusableSelector = 'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

	// @ngInject
	constructor(
	    private $timeout : ng.ITimeoutService,
	    private contentService: ContentService,
	    private $element
	){}
	
	public $onInit = () => {
	    this.isOpen = true;

	    // Store the element that had focus before the modal opened
	    this.previouslyFocusedElement = document.activeElement as HTMLElement;

	    if( this.folderId?.trim() ){
	        this.modalTitle = "Edit Folder";
	        this.modalInputLabel = this.folderName;
	    } 
	    else {
	        this.modalInputLabel = 'Folder Name'; //we're creating a new folder
	    }

	    // Set initial focus to the close button after render
	    this.$timeout(() => {
	        const modalEl = this.$element[0].querySelector('.modal');
	        if (modalEl) {
	            modalEl.removeAttribute('aria-hidden');
	            const closeBtn = modalEl.querySelector('.close') as HTMLElement;
	            if (closeBtn) {
	                closeBtn.focus();
	            }
	        }
	    });
	}
	
	public onSave = () => {
	    
	    if( this.folderId?.trim() ){
	        this.updateFolder();
	    } 
	    else {
	        this.createFolder();
	    }
	}
	
	public createFolder = () => {
		this.isLoading = true;
		this.contentService.createFolder(this.folderName, this.folderType)
		.then( res => {
			if( !res?.successfulActions?.includes('createFolder') ){
				throw(res)
			}
			this.isSaveSuccess = true;
			this.successMessage = `Folder ${this.folderName} has been created successfully`;
		})
		.finally(() => this.isLoading = false);
	}
	
	public updateFolder = () => {
	    this.isLoading = true;
	    this.contentService.updateFolder({
            folderID: this.folderId, 
            title: this.folderName, 
            folderType_systemCode: this.folderType
        })
        .then( (res) => {
            if( !res?.successfulActions?.includes('updateFolder') ){
                throw(res);
            }
            this.isSaveSuccess = true;
            this.successMessage = `Folder ${this.folderName} has been updated successfully`;
        })
        .finally(() => this.isLoading = false);
	}
	
    public handleKeydown = (event: KeyboardEvent) => {
        if (event.key === 'Escape' || event.keyCode === 27) {
            event.preventDefault();
            this.closeModal();
        }

        if (event.key === 'Tab' || event.keyCode === 9) {
            this.trapFocus(event);
        }
    }

    private trapFocus = (event: KeyboardEvent) => {
        const modalEl = this.$element[0].querySelector('.modal');
        if (!modalEl) return;

        const focusableElements = modalEl.querySelectorAll(this.focusableSelector);
        if (focusableElements.length === 0) return;

        const firstFocusable = focusableElements[0] as HTMLElement;
        const lastFocusable = focusableElements[focusableElements.length - 1] as HTMLElement;

        if (event.shiftKey) {
            if (document.activeElement === firstFocusable) {
                event.preventDefault();
                lastFocusable.focus();
            }
        } else {
            if (document.activeElement === lastFocusable) {
                event.preventDefault();
                firstFocusable.focus();
            }
        }
    }

    private closeModal = () =>{
    	if( this.sourcePage == "listing") {
    		this.close({ 'status': this.isSaveSuccess, 'folderName': this.folderName });
    	} else {
    		this.close(this.isSaveSuccess);
    	}
		this.isOpen = false;

		// Restore focus to the previously focused element
		if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
		    this.previouslyFocusedElement.focus();
		}
	}
    
}

class AddEditFolderModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    folderId: "<",
	    folderName: "<",
	    folderType: "<?",
	    sourcePage: "<?",
		close:'='
	};

	public controller = AddEditFolderModalController;
	public controllerAs = 'folderModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/add-edit-folder-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { AddEditFolderModal };
